<template>
    <div class="container admin-table-page">
        <!-- Fila del título y flecha hacia atrás -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" class="back-icon" />
                    </b-button>
                    <h2 class="param-title">{{ labels.title }}</h2>
                </div>
            </div>
        </div>
        <!-- Fila de filtros debajo del título a la izquierda -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="filters-container d-flex align-items-center">
                    <input type="month" v-model="fechaCierre" class="form-control">
                    <b-button
                        class="consult-btn mx-3"
                        :disabled="!fechaCierre"
                        @click="procesarCierre()"
                    >
                        {{ labels.procesar }}
                    </b-button>
                </div>
            </div>
        </div>

        <!-- <div class="row mt-5">
            <div class="col-md-6 d-flex justify-content-end">
                <h4>{{ labels.fechaCierre }}</h4> 
            </div>
            <div class="col-md-2 d-flex justify-content-start" v-if="chkCierre == 1">
                <input type="month" :items="fechaCierre" class="form-control" readonly>
            </div>
            <div v-else>
                <input type="month" :items="fechaCierre" class="form-control">
            </div>
        </div>
        <div class="col-md-12 mt-4" v-if="!loading">
            <b-button type="button" id="create-btn" @click="procesarCierre">{{ labels.procesar }}</b-button> 
        </div>
        <b-row v-if="loading" class="justify-content-center mt-5">
            <b-spinner
                class="spinner-border"
            ></b-spinner>
        </b-row> -->
        <!-- Spinner de carga -->
        <div v-if="loading" class="text-center py-5">
            <b-spinner></b-spinner>
            <p class="mt-2">{{ labels.loading }}</p>
        </div>
        <!-- <ConsultaCierreMensual :listCierreMensual="listCierreMensual"></ConsultaCierreMensual> -->
    </div>
</template>

<script>
import ContratoCierre from '../../services/ContratoCierre'; 
// import ConsultaCierreMensual from '../consultaCierres/ConsultaCierreMensual.vue'; 
import FechaRegistro from '../../services/FechaRegistro'; 
export default {
    name : 'CierreMensual',
    // components : { ConsultaCierreMensual },
    data: () => ({
        fechaCierre : '',
        listCierreMensual : [],
        chkCierre : 0,
        loading: false,
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Cierre mensual',
                    fechaCierre : 'Fecha cierre:',
                    procesar : 'Procesar',
                    loading : 'Cargando...',
                }
            }else{
                return {
                    title : 'Monthly closing',
                    fechaCierre : 'Closing date:',
                    procesar : 'Process',
                    loading : 'Cargando...',
                }
            }
        }
    },
    methods:{
        goBack(){
            this.$router.back()
        },
        procesarCierre() {
/*
            const fecha = new Date();
            const mes = String(fecha.getMonth() + 1).padStart(2, '0'); 
            const anio = fecha.getFullYear(); 
            const fechaActual = `${anio}-${mes}`; // formato correcto YYYY-MM

            if (!this.fechaCierre) { 
                this.$toast.error('Diligenciar la fecha.'); 
                return;
            }

            // Comparación correcta entre fechas YYYY-MM
            if (this.fechaCierre >= fechaActual) { 
                this.$toast.error('La fecha cierre no puede ser igual o mayor al mes actual.'); 
                return;
            }
*/
            const datos = {
                fechaCierre: this.fechaCierre, 
                idUser: this.$store.state.userId 
            };

            this.loading = true 

            ContratoCierre.createCierreContrato(datos) 
            .then((res) => { 
                this.$toast.success(res.data.message); 
                this.consultaCierres(); 
            })
            .catch((err) => { 
                if (err.response?.status === 500) { 
                    this.$toast.error(err.response.data.error); 
                } else {
                    this.$toast.error("Algo pasó, inténtalo de nuevo"); 
                }
            })
            .finally(() => { 
                this.loading = false 
            });
        },
        consultaCierres(){
            ContratoCierre.getContratoCierreByFecha(this.fechaCierre) 
            .then((res) => { 
                // console.log(res.data); 
                this.listCierreMensual = res.data.listContratosCerrados 
            })
            .catch((err) => console.log(err)) 
        }
    },
    mounted(){

        FechaRegistro.getAllFechaRegistro() 
        .then((res) => { 
            // console.log(res.data); 
            this.fechaCierre = res.data.periodo_cierre 
            this.chkCierre = res.data.flag_cierre 
        })
        .catch((err) => { 
            console.log(err); 
            if(err.response.status == 500){ 
                this.$toast.error(err.response.data.msg) 
            }else{
                this.$toast.error("Algo pasó, intentalo de nuevo") 
            }
        })
    }
}
</script>

<style>
.consult-btn {
    background-color: #016690 !important;
    border-color: #016690 !important;
    color: white !important;
}

.consult-btn:disabled {
    background-color: #6c757d !important;
    border-color: #6c757d !important;
    color: #FFFFFF !important;
    cursor: not-allowed;
    opacity: 1 !important;
}

.consult-btn:not(:disabled):hover {
    background-color: #015577 !important;
    border-color: #015577 !important;
}
</style>
